import { render } from "./ListePaysPage.vue?vue&type=template&id=6ad56f3e&ts=true"
import script from "./ListePaysPage.vue?vue&type=script&lang=ts"
export * from "./ListePaysPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__